import { Form, Row, Col } from 'react-bootstrap';
import OptionEntry from '../optionEntry/optionEntry';
import RadioItems from '../radioItems/radioItems';
import TextEntry from '../textEntry/textEntry';
import CheckBoxItems from '../checkBoxItems/checkBoxItems';
import AttachmentManager from '../attachment/attachmentManager';
import './dynamic-form.scss';
import SingleCheckbox from '../singleCheckbox/singleCheckbox';
import CheckboxWithModel from '../checkboxWithModel/checkboxWithModel';
import _ from 'lodash';

const DynamicForm = (props) => {


  const collapsibleRefs = {};

  const createLabel = (entry, data) => {
    if(entry.isVisible === undefined || entry.isVisible === null || (entry.isVisible && (typeof entry.isVisible === 'function') && entry.isVisible(data))) {
      return <Form.Label style={entry.style} className={entry.className}>{entry.label}</Form.Label>;
    }
    return <></>;
  };

  const createTextEntry = (entry, data, onChangeHandler) => {
    return (
      <TextEntry
        entry={entry}
        value={data}
        onChangeHandler={onChangeHandler}
      ></TextEntry>
    );
  };

  const createOptionEntry = (entry, data, options, onChangeHandler) => {
    return (
      <OptionEntry entry={entry} value={data} options={options} onChangeHandler={onChangeHandler}></OptionEntry>
    );
  };

  const createRadioEntry = (entry, data, options, onChangeHandler) => {
    return (
      <RadioItems entry={entry} value={data} options={options} onChangeHandler={onChangeHandler}></RadioItems>
    );
  };

  const createCheckboxEntry = (entry, data, options, onChangeHandler) => {
    return (
      <CheckBoxItems entry={entry} value={data} options={options} onChangeHandler={onChangeHandler} aditionalName='Other'></CheckBoxItems>
    );
  };

  const createSingleCheckboxEntry = (entry, incomingData, data, onChangeHandler) => {
    if (entry.isCollapsible) {
      const isChecked = !!data[entry.mapToProp];

      return (
        <div key={`container-${entry.type}-${entry.mapTo}`}>
          <SingleCheckbox entry={entry} value={data} onChangeHandler={(mapTo, val) => {
            onChangeHandler(mapTo, val);
            collapsibleRefs[`collapsible-${entry.type}-${entry.mapTo}`].style.display = val ? 'block' : 'none';
          }}>
          </SingleCheckbox>
          <div
            key={`collapsible-${entry.type}-${entry.mapTo}`}
            ref={e => collapsibleRefs[`collapsible-${entry.type}-${entry.mapTo}`] = e}
            style={{ display: isChecked ? 'block' : 'none' }}>
            {mapRows(entry.rows, incomingData, 'collapsible')}
          </div>
        </div>
      );
    } else {
      return (<SingleCheckbox entry={entry} value={data} onChangeHandler={onChangeHandler}></SingleCheckbox>);
    }
  };

  const createCheckboxWithModel = (entry, data, options, onChangeHandler) => {
    return (<CheckboxWithModel entry={entry} value={data} onChangeHandler={onChangeHandler} options={options}></CheckboxWithModel>);
  };

  const formatOptions = (options) => {
    for (let index = 0; index < options.length; index++) {
      let entry = options[index];
      let lastIndex = entry.mapTo.lastIndexOf('.');
      options[index].mapToProp = entry.mapTo.substr(lastIndex + 1, entry.mapTo.length);
    }
  };

  const getData = (data, entry) => {
    if (!entry.mapTo) {
      return data;
    }

    let lastIndex = entry.mapTo.lastIndexOf('.');

    if (lastIndex === -1) {
      entry.mapToProp = entry.mapTo;
      return data;
    }

    let field = entry.mapTo.substr(0, lastIndex);

    let dataObject = _.get(data, field);
    if (!dataObject) {
      _.set(data, field, {});
      dataObject = _.get(data, field);
    }

    entry.mapToProp = entry.mapTo.substr(lastIndex + 1, entry.mapTo.length);

    return dataObject;
  };

  const data = props.data;

  const getEntryComponent = (entry, incomingData, onChangeHandler) => {
    let data = getData(incomingData, entry);

    if (entry.sections) {
      return mapSections(entry.sections, data, onChangeHandler);
    }


    switch (entry.type) {
      case 'select':
        return createOptionEntry(entry, data, entry.options, onChangeHandler);
      case 'radio':
        return createRadioEntry(entry, data, entry.options, onChangeHandler);
      case 'checkbox':
        return createCheckboxEntry(entry, data, entry.options, onChangeHandler,);
      case 'label':

        return  createLabel(entry, props.data);
      case 'documentUpload':
        return <AttachmentManager control={props.mainControl}></AttachmentManager>;
      case 'singleCheckbox':
        return createSingleCheckboxEntry(entry, incomingData, data, onChangeHandler);
      case 'checkboxwithmodel':
        formatOptions(entry.options);
        return createCheckboxWithModel(entry, getData(data, entry.options[0]), entry.options, onChangeHandler);
      default:
        return createTextEntry(entry, data, onChangeHandler);
    }
  };

  const dataChangeHandler = (mapTo, value) => {
    _.set(data, mapTo, value);

    props.mainControl.onChangeHandler(data);
  };

  const mapRows = (rows, data, prefix) => {
    return rows.map((row, index) => {
      return (
        <Row className={prefix + '-row'} style={row.style} key={prefix + '_row_' + index}>
          {row.cols.map((entry, colIndex) => {
            return (
              <Col md="auto" key={prefix + '_column_' + colIndex}>
                {
                  entry.type? 
                    getEntryComponent(entry, data, dataChangeHandler) 
                    :
                    entry.rows && _.isArray(entry.rows) ?
                      mapRows(entry.rows, data, prefix + '_row_' + index + '_col_' + colIndex + '_rows')
                      :
                      getEntryComponent(entry, data, dataChangeHandler)
                }
              </Col>
            );
          })
          }
        </Row>
      );
    });
  };

  const mapSections = (sections, data) => {
    return sections.map((section, index) => {

      return (
        <Row className={'section ' + (section.className)} style={section.style} key={'row_' + index + section.title}>
          <Col md="auto" key={'column_' + index + section.title}>
            {section.title ?
              <Form.Label className="dynamic-form-title" key={'label_' + index + section.title}>
                {section.title}
              </Form.Label>
              : null
            }
            {mapRows(section.rows, data, 'section')}
          </Col>
        </Row>
      );
    });
  };

  return (
    <Form className="dynamic-form">
      {mapSections(props.sections, data)}
    </Form>
  );
};



export default DynamicForm;